import { type KeyedExternalFile, type KeyedImage } from '.';
import { SavingState } from '@/components/FileAttachments/AddFiles/getSavingState';

const getLogEntryFilesSavingState = (
  saving: boolean,
  images: KeyedImage[],
  externalFiles: KeyedExternalFile[],
): SavingState => {
  if (!saving) {
    return SavingState.NOT_SAVING;
  }

  if (images.length > 0 && externalFiles.length > 0) {
    return SavingState.BOTH;
  }

  if (images.length > 0) {
    return SavingState.IMAGES;
  }

  if (externalFiles.length > 0) {
    return SavingState.EXTERNAL_FILES;
  }

  return SavingState.NOT_SAVING;
};

export default getLogEntryFilesSavingState;
